module.exports = __webpack_public_path__ + "img/territorial.89a172ed.svg";